import type * as router from '@attain-apps/fe/web/main/lib/router'

import type { Values } from './values'

export type LinkValues = Values
export namespace LinkValues {
  /**
   * {@link router.models.EncodedQueryParam.Scope} where all {@link LinkValues}
   * are stored
   */
  export const SCOPE: router.models.EncodedQueryParam.Scope = ['linkVars']
}
